import { render, staticRenderFns } from "./Negozio.vue?vue&type=template&id=6a230a1f"
import script from "./Negozio.vue?vue&type=script&lang=js"
export * from "./Negozio.vue?vue&type=script&lang=js"
import style0 from "./Negozio.vue?vue&type=style&index=0&id=6a230a1f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports